import { render } from "./ManagementDashboard.vue?vue&type=template&id=45dfc4da"
import script from "./ManagementDashboard.vue?vue&type=script&lang=js"
export * from "./ManagementDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__